function Footer() {
  return (
    <footer className="bg-background-soft border-t border-neutral-800">
      <div className="container mx-auto px-6 py-14 lg:px-28 lg:max-w-full grid gap-10 md:grid-cols-4">
        {/* Marca */}
        <div className="md:col-span-2">
          <p className="font-display text-2xl text-neutral-50">THIAGO VIEIRA</p>
          <p className="text-xs text-gold-500 tracking-[0.2em] uppercase ">
            Personal Trainer
          </p>
          <p className="text-xs text-neutral-50 tracking-[0.2em] uppercase mb-4 mt-1">CREF/SC 040542-G /SC</p>
          <p className="text-neutral-400 text-sm max-w-sm">
            Treinamento personalizado para emagrecimento, hipertrofia e
            performance. Resultados reais, com acompanhamento profissional.
          </p>
        </div>

        {/* Links */}
        <div className="text-neutral-50 font-semibold mb-4 hidden">
          <h4 className="text-neutral-50 font-semibold mb-4 hidden">Navegação</h4>
          <ul className="space-y-2 text-sm text-neutral-400">
            <li><a href="#servicos"    className="hover:text-gold-500">Serviços</a></li>
            <li><a href="#planos"      className="hover:text-gold-500">Planos</a></li>
            <li><a href="#depoimentos" className="hover:text-gold-500">Depoimentos</a></li>
            <li><a href="#contato"     className="hover:text-gold-500">Contato</a></li>
          </ul>
        </div>

        {/* Contato */}
        <div>
          <h4 className="text-neutral-50 font-semibold mb-4">Contato</h4>
          <ul className="space-y-2 text-sm text-neutral-400">
            <li>Palhoça, SC</li>
            <li>thiagomfv@icloud.com</li>
            <li>
              <a
                href="https://wa.me/5548999145340?text=Olá! Gostaria de saber mais sobre os seus serviços."
                className="inline-flex items-center gap-2 text-success hover:opacity-80"
              >
                WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-neutral-800">
        <div className="container mx-auto px-6 py-5 text-xs text-neutral-400 flex flex-col md:flex-row items-center justify-between gap-2">
          <p>© {new Date().getFullYear()} Softbridge Sistemas. Todos os direitos reservados.</p>
          <p></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
